import createItemFetcher from "../helpers/item";
import { createUseFetch } from "../helpers/fetchHooks";
export { SUMType } from "./sum";
const sumConfig = createItemFetcher(() => "/api/v1/sum/config", "SUM_CONFIG", () => "main", (resp) => resp.items);
export const createSumConfig = () => sumConfig;
export const useSumConfig = createUseFetch(sumConfig, (state) => state.sum);
//# sourceMappingURL=index.js.map